"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import VerifyPhoneDialog from "@/views/virtualdesktopItems/components/dialog-forms/VerifyPhoneDialog.vue";
import CheckTOTPCode from "@/views/virtualdesktopItems/components/dialog-forms/CheckTOTPCode.vue";
import CheckTOTPQrCode from "@/views/virtualdesktopItems/components/dialog-forms/CheckTOTPQrCode.vue";
import { AccountSessionMixins } from "@/service/account-session";
import { Debounce } from "vue-debounce-decorator";
let BindTOTPByListDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    // gridController = new GridController<any>(new APIDataSource("api://base.auth/api/v9/shop-two-step-verifications"));
    this.gridController = new GridController(new APIDataSource("api://base.auth.pro/v1/shop-two-step-verifications"));
    this.selectDatas = [];
    this.selectLock = false;
    this.activeName = "first";
    this.searchStr = "";
    this.rows = [];
    this.isDelete = false;
    this.selectType = "";
  }
  created() {
    this.gridController.pagePosition = "dialog";
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.size = true;
  }
  mounted() {
  }
  selectable(row, index) {
    let _data = this._distributionDialog.getAllNew();
    if (_data.length > 0) {
      for (const item of _data) {
        if (item.id === row.id) {
          return true;
        }
      }
      return false;
    }
    if (_data.length === 0) {
      return true;
    }
    return false;
  }
  // 查看TOTP验证码
  checkTOTPCode(row) {
    return __async(this, null, function* () {
      try {
        yield API.get(`api://base.local/storages/session/totpCode`);
        this.openTotpDialog("totp-code-verify", row);
      } catch (error) {
        this._verify_phone_dialog.open("totp-code-verify", row);
      }
    });
  }
  // 查看TOTP二维码
  checkTOTPQrcode(row) {
    return __async(this, null, function* () {
      try {
        yield API.get(`api://base.local/storages/session/totpQrcode`);
        this.openTotpDialog("totp-qrcode-verify", row);
      } catch (error) {
        this._verify_phone_dialog.open("totp-qrcode-verify", row);
      }
    });
  }
  openTotpDialog(type, row) {
    return __async(this, null, function* () {
      if (type === "totp-code-verify") {
        this._check_totp_code.open(row);
      }
      if (type === "totp-qrcode-verify") {
        this._check_totp_qr_code.open(row);
      }
    });
  }
  open(data) {
    return __async(this, null, function* () {
      this.searchStr = "";
      this.selectDatas = [];
      this.selectLock = false;
      this.gridController.query.filter = "";
      this.gridController.query.current = 1;
      this.gridController.query.size = 10;
      this.gridController.search();
      this._distributionDialog.open();
      this._distributionDialog.setOptSpan(16, 8);
      this.$nextTick(() => __async(this, null, function* () {
        if (data) {
          let arr = [];
          arr.push(data);
          this.selectItemNew(arr);
        }
      }));
    });
  }
  saved(data) {
    return __async(this, null, function* () {
      let uploadData = data[0];
      this.$message.success(this.$t("shopbindvd.binding_successful"));
      this._distributionDialog.close();
      this.gridController.query.filter = "";
      this.gridController.query.current = 1;
      this.gridController.query.size = 100;
      yield this.gridController.search();
      let item = _.find(this.gridController.result.datas, { "id": uploadData.id });
      let realData = {
        "id": item.id,
        "secret": item.secret,
        "username": item.account,
        "name": item.name,
        "bindShopNum": item.bindShopNum
      };
      this.$emit("uploadSuccess", realData);
    });
  }
  deleteTotp(row) {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(this.$t("config_totp_dialog.delete_tip_content"), this.$t("config_totp_dialog.delete_tip_title"), {
          confirmButtonText: this.$t("headertoolbar.confirm"),
          cancelButtonText: this.$t("headertoolbar.cancel"),
          customClass: "new-confirm-box",
          iconClass: "el-icon-warning"
        });
        let item = _.find(this.selectDatas, { "id": row.id });
        if (item !== void 0) {
          this.selectDatas = [];
          this._distributionDialog.clear();
          this.$emit("deleteTOTP");
        } else {
          yield API.delete(`api://base.auth.pro/v1/shop-two-step-verifications/${row.id}`);
          this.$message.success(this.$t("virtualdesktopform.delete_totp_success"));
        }
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  selectItemNew(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    for (const item of this.selectDatas) {
      const _item = {
        id: item["id"],
        label: item["name"]
      };
      this._distributionDialog.add(_item);
    }
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      if (this._distributionDialog.getAll().length >= 1 && items.length !== 0 || items.length > 1) {
        this.$message.error(this.$t("shopbindvd.a_store_can_only_bind_one"));
        return;
      }
      this._distributionDialog.syncData(this.gridController.result.datas, items, "id", "name");
    }
  }
  changed(data) {
    this.selectLock = true;
    let rows = _.differenceWith(this.selectDatas, data, (selectData, data2) => selectData.id == data2.id);
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  checkItem() {
    this.selectLock = true;
    let selectDatas = this._distributionDialog.getAll();
    let rows = _.intersectionWith(this.gridController.result.datas, selectDatas, (selectData, data) => selectData.id == data.id);
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    _.debounce(() => {
      this.selectLock = false;
    }, 600);
  }
  searchByName(searchStr) {
    this.gridController.query.filter = "";
    if (searchStr !== null && searchStr !== "") {
      this.gridController.query.filter = `name=like='${searchStr}';`;
      console.log(this.selectType);
      if (this.selectType !== "") {
        console.log(this.selectType);
        this.gridController.query.filter += `ebusinessCode=='${this.selectType}';`;
      }
    }
    if (searchStr === null || searchStr === "") {
      if (this.selectType !== "") {
        this.gridController.query.filter = `ebusinessCode=='${this.selectType}';`;
      }
    }
    this.gridController.query.current = 1;
    this.gridController.search();
  }
  changeSelectType() {
    return __async(this, null, function* () {
      console.log(this.selectType);
      this.gridController.query.filter = "";
      if (this.selectType !== "") {
        this.gridController.query.filter = `ebusinessCode=='${this.selectType}';`;
        if (this.searchStr !== null && this.searchStr !== "") {
          this.gridController.query.filter += `name=like='${this.searchStr}';`;
        }
      } else {
        if (this.searchStr !== null && this.searchStr !== "") {
          this.gridController.query.filter = `name=like='${this.searchStr}';`;
        }
      }
      this.gridController.query.current = 1;
      this.gridController.search();
    });
  }
};
__decorateClass([
  Ref("distributionDialog")
], BindTOTPByListDialog.prototype, "_distributionDialog", 2);
__decorateClass([
  Ref("multipleTable")
], BindTOTPByListDialog.prototype, "_multipleTable", 2);
__decorateClass([
  Ref("verify_phone_dialog")
], BindTOTPByListDialog.prototype, "_verify_phone_dialog", 2);
__decorateClass([
  Ref("check_totp_code")
], BindTOTPByListDialog.prototype, "_check_totp_code", 2);
__decorateClass([
  Ref("check_totp_qr_code")
], BindTOTPByListDialog.prototype, "_check_totp_qr_code", 2);
__decorateClass([
  Debounce(500)
], BindTOTPByListDialog.prototype, "searchByName", 1);
__decorateClass([
  Debounce(500)
], BindTOTPByListDialog.prototype, "changeSelectType", 1);
BindTOTPByListDialog = __decorateClass([
  Component({
    components: {
      UiGrid,
      DistributionDialog,
      VerifyPhoneDialog,
      CheckTOTPCode,
      CheckTOTPQrCode
    }
  })
], BindTOTPByListDialog);
export {
  BindTOTPByListDialog as default
};
